// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"c3b5509269b6eea09b89","147":"0b4c06e792da1bf31625","251":"1484a186a753c2b52204","265":"88cbfd9a071139a17262","352":"0a96620d5d9713e04d38"}[chunkId] + ".js";
};